import { createAction } from '../../../store.model';
import { SearchItem, SearchParams } from '../../core';
import { ActionType } from '../search.action';

export interface RunSearch {
    params: SearchParams;
}

export const runSearch = createAction<ActionType, RunSearch>(
    ActionType.EVAL_SEARCH__RUN_SEARCH,
);

export interface RunSearchResult extends RunSearch {
    data?: SearchItem[];
}

export const runSearchResult = createAction<ActionType, RunSearchResult>(
    ActionType.EVAL_SEARCH__RUN_SEARCH_RESULT,
);
